"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const FeeUtil_1 = __importDefault(require("./FeeUtil"));
const IOrderType_1 = require("../interfaces/IOrderType");
const PaymentUtil_1 = __importDefault(require("./PaymentUtil"));
// import IFee from '../interfaces/IFee';
const IFee_1 = require("../interfaces/IFee");
exports.default = {
    isComp(order) {
        const { type = 'Online' } = order;
        return type === IOrderType_1.OrderTypeEnum.Complimentary;
    },
    isRSVP(order) {
        const { type = 'Online' } = order;
        return type === IOrderType_1.OrderTypeEnum.RSVP;
    },
    isShared(order) {
        const { type = 'Online' } = order;
        return type === IOrderType_1.OrderTypeEnum.Shared;
    },
    /*****************************************************************************************
    Order
    *****************************************************************************************/
    orderTotal(order, fees) {
        if ((order === null || order === void 0 ? void 0 : order.payments) && (order === null || order === void 0 ? void 0 : order.payments.length) > 0) {
            return order.payments.reduce((cur, payment) => {
                return cur + PaymentUtil_1.default.calculatePaymentTotal({
                    tickets: order.tickets.filter(ticket => ticket.paymentId === payment._id),
                    upgrades: order.upgrades.filter(upgrade => upgrade.paymentId === payment._id),
                    fees: fees,
                    paymentMethodType: payment.paymentMethodType,
                }).total || 0;
            }, 0);
        }
        else {
            if ((!order.tickets || !order.tickets.length) &&
                (!order.upgrades || !order.upgrades.length))
                return 0;
            if (!order.tickets)
                order.tickets = [];
            if (!order.upgrades)
                order.upgrades = [];
            const ticketTotal = order.tickets.reduce((cur, ticket) => cur + ticket.price, 0);
            const upgradeTotal = order.upgrades.reduce((cur, upgrade) => cur + upgrade.price, 0);
            const totalFee = fees.reduce((cur, fee) => cur + parseInt(fee.amount), 0);
            // console.log("++++>>>>>>", ticketTotal, upgradeTotal, totalFee)
            const orderSubtotal = ticketTotal + upgradeTotal + totalFee;
            // console.log("++++",orderSubtotal)
            return Math.round(orderSubtotal);
        }
    },
    guestFees(order, fees) {
        let guestTicketFees = fees.find((fee) => {
            const filter = fee === null || fee === void 0 ? void 0 : fee.filters;
            return filter.includes(IFee_1.FeeFiltersEnum.GuestTicket);
        });
        let guestFeesValue = (guestTicketFees === null || guestTicketFees === void 0 ? void 0 : guestTicketFees.value) || 0;
        // const ticketTotal = order.tickets.reduce((cur, ticket) => cur + ticket.price - ticket.refund.refundedAmount, 0);
        const ticketTotal = order.tickets.reduce((cur, ticket) => cur + ticket.price - ticket.refund.refundedAmount, 0);
        let guestMembers = order.tickets.filter((a) => a.guestTicket).length;
        // let guestMembers = order.tickets.filter((a) => a.guestTicket && a.refund.refunded == false).length;
        let guestMembersRefunded = order.tickets.filter((a) => a.guestTicket && a.refund.refunded == true).length;
        const stripeFees = fees.find((fee) => fee.appliedBy === IFee_1.FeeAppliedByEnum.Stripe && fee.type === IFee_1.FeeTypeEnum.Percent);
        let guestFees;
        let guestFeesRefunded;
        if ((guestTicketFees === null || guestTicketFees === void 0 ? void 0 : guestTicketFees.type) === "Flat") {
            guestFees = guestFeesValue * guestMembers;
            guestFeesRefunded = guestFeesValue * guestMembersRefunded;
        }
        else if ((guestTicketFees === null || guestTicketFees === void 0 ? void 0 : guestTicketFees.type) === "Percent") {
            guestFees = (ticketTotal * guestFeesValue) / 100;
            guestFeesRefunded = (ticketTotal * guestMembersRefunded) / 100;
        }
        let stripeFeeAmount = 0;
        if (stripeFees === null || stripeFees === void 0 ? void 0 : stripeFees.value) {
            stripeFeeAmount = Math.round(guestFees * (stripeFees === null || stripeFees === void 0 ? void 0 : stripeFees.value) / 100);
        }
        return {
            guestFees: guestFees || 0,
            guestFeesRefunded: guestFeesRefunded || 0,
            stripeFeeAmount: stripeFeeAmount || 0
        };
    },
    orderTotalWithRefund(order, fees) {
        const orderTotal = this.orderTotal(order, fees);
        return orderTotal - (order.refundedAmount || 0);
    },
    orderTransferAmountWithRefund(order, fees) {
        const promoterFees = FeeUtil_1.default.promoterFees(fees);
        return this.orderTotalWithRefund(order, promoterFees);
    },
    orderSubtotal(order) {
        var _a;
        let subTotal;
        if (order === null || order === void 0 ? void 0 : order.payments) {
            subTotal = (_a = order === null || order === void 0 ? void 0 : order.payments) === null || _a === void 0 ? void 0 : _a.reduce((cur, payment) => {
                return cur + PaymentUtil_1.default.calculatePaymentSubtotal({
                    tickets: order.tickets.filter(ticket => ticket.paymentId === payment._id),
                    upgrades: order.upgrades.filter(upgrade => upgrade.paymentId === payment._id),
                    fees: [],
                    paymentMethodType: payment.paymentMethodType,
                });
            }, 0);
        }
        else {
            subTotal = PaymentUtil_1.default.calculatePaymentSubtotalValue({
                tickets: order === null || order === void 0 ? void 0 : order.tickets,
                upgrades: order === null || order === void 0 ? void 0 : order.upgrades
            });
        }
        return subTotal || 0;
    },
    orderSubtotalWithRefund(order) {
        if (order.type === IOrderType_1.OrderTypeEnum.Complimentary)
            return 0;
        if (!order.tickets)
            order.tickets = [];
        if (!order.upgrades)
            order.upgrades = [];
        const ticketTotal = order.tickets.reduce((cur, ticket) => cur + ticket.price - ticket.refund.refundedAmount, 0);
        const upgradeTotal = order.upgrades.reduce((cur, upgrade) => cur + upgrade.price - upgrade.refund.refundedAmount, 0);
        return ticketTotal + upgradeTotal;
    },
    ticketsSubtotal(order) {
        if (!order.tickets)
            order.tickets = [];
        return order.tickets.reduce((cur, ticket) => cur + ticket.price, 0);
    },
    ticketsSubtotalWithRefund(order) {
        if (!order.tickets)
            order.tickets = [];
        return order.tickets.reduce((cur, ticket) => cur + ticket.price - ticket.refund.refundedAmount, 0);
    },
    upgradesSubtotal(order) {
        if (!order.upgrades)
            order.upgrades = [];
        return order.upgrades.reduce((cur, upgrade) => cur + upgrade.price, 0);
    },
    upgradesSubtotalWithRefund(order) {
        if (!order.upgrades)
            order.upgrades = [];
        return order.upgrades.reduce((cur, upgrade) => cur + upgrade.price - upgrade.refund.refundedAmount, 0);
    },
    orderFee(order, fees) {
        if (!order.tickets)
            order.tickets = [];
        if (!order.upgrades)
            order.upgrades = [];
        return this.orderTotal(order, fees) - this.orderSubtotal(order);
    },
    // This one is special because stripe fees
    // can be applied as a percentage
    processingFees(order, fees) {
        if (!order.tickets)
            order.tickets = [];
        if (!order.upgrades)
            order.upgrades = [];
        const total = this.orderTotal(order, fees);
        const subtotal = this.orderSubtotal(order);
        const promoterFees = this.promoterFees(order, fees);
        return total - subtotal - promoterFees;
    },
    selloutFees(order, fees) {
        if (!order.tickets)
            order.tickets = [];
        if (!order.upgrades)
            order.upgrades = [];
        fees = FeeUtil_1.default.selloutFees(fees);
        return this.orderTotal(order, fees) - this.orderSubtotal(order);
    },
    // This one is special because stripe fees
    // can be applied as a percentage
    stripeFees(order, fees) {
        if (!order.tickets)
            order.tickets = [];
        if (!order.upgrades)
            order.upgrades = [];
        const total = this.orderTotal(order, fees);
        const subtotal = this.orderSubtotal(order);
        const selloutFees = this.selloutFees(order, fees);
        const promoterFees = this.promoterFees(order, fees);
        let stripeFee = total - subtotal - selloutFees - promoterFees;
        let stripeFeeT = stripeFee < 0 ? 0 : stripeFee;
        return stripeFeeT;
    },
    promoterFees(order, fees) {
        if (!order.tickets)
            order.tickets = [];
        if (!order.upgrades)
            order.upgrades = [];
        fees = FeeUtil_1.default.promoterFees(fees);
        return this.orderFee(order, fees);
    },
    promoterFeesWithRefund(order, fees) {
        if (order.state === 'Refunded') {
            return 0;
        }
        if (order.state === 'Partial Refund') {
            const orderTotalWithRefund = this.orderTotalWithRefund(order, fees);
            const orderSubtotal = this.orderSubtotal(order, fees);
            if (order.refundedAmount > orderSubtotal) {
                const processingFees = this.processingFees(order, fees);
                return orderTotalWithRefund - processingFees;
            }
        }
        return this.promoterFees(order, fees);
    },
    /*****************************************************************************************
    Ticket
    *****************************************************************************************/
    ticketTypeTotal(order, ticketTypeId) {
        return order.tickets
            .filter(t => t.ticketTypeId === ticketTypeId)
            .reduce((cur, next) => cur + (next.origionalPrice ? next.origionalPrice : next.price), 0);
    },
    ticketCountsByTicketTypeId(order) {
        return order.tickets.reduce((cur, ticket) => {
            // TODO - handle canceled tickets
            // if (ticket.state === "Canceled") return cur;
            if (cur[ticket.ticketTypeId])
                cur[ticket.ticketTypeId]++;
            else
                cur[ticket.ticketTypeId] = 1;
            return cur;
        }, {});
    },
    ticketTypeCount(order, ticketTypeId) {
        const counts = this.ticketCountsByTicketTypeId(order);
        return counts[ticketTypeId] || 0;
    },
    ticketIsScannable(orderTicket) {
        if (!orderTicket)
            return false;
        const { scan = {}, refund = {} } = orderTicket;
        if (scan.scanned && scan.scannedAt > 0)
            return false;
        if (refund.refunded && refund.refundedAt > 0)
            return false;
        return true;
    },
    seatIsSelected(order, seat) {
        const allSeats = this.allSeats(order);
        return allSeats.includes(seat);
    },
    allSeats(order) {
        return order.tickets
            .filter(ticket => Boolean(ticket.seat))
            .map(ticket => ticket.seat);
    },
    ticketTypeSeats(order, ticketTypeId) {
        return order.tickets
            .filter(ticket => ticket.ticketTypeId === ticketTypeId)
            .filter(ticket => Boolean(ticket.seat && ticket.state == "Shared"))
            .map(ticket => ticket.seat);
    },
    ticketTypeSeatsActive(order, ticketTypeId) {
        return order.tickets
            .filter(ticket => ticket.ticketTypeId === ticketTypeId)
            .filter(ticket => Boolean(ticket.seat && ticket.state == "Active"))
            .map(ticket => ticket.seat);
    },
    ticketTypeSeatsOffered(order, ticketTypeId) {
        return order.tickets
            .filter(ticket => ticket.ticketTypeId === ticketTypeId)
            .filter(ticket => Boolean(ticket.seat && ticket.state == "Offered"))
            .map(ticket => ticket.seat);
    },
    /*****************************************************************************************
    Upgrade
    *****************************************************************************************/
    upgradeTypeTotal(order, upgradeId) {
        return order.upgrades
            .filter(t => t.upgradeId === upgradeId)
            .reduce((cur, next) => cur + next.price, 0);
    },
    upgradeCount(order, upgradeId) {
        const counts = this.upgradeCountsByTicketTypeId(order);
        return counts[upgradeId] || 0;
    },
    upgradeCountsByTicketTypeId(order) {
        return order.upgrades.reduce((cur, upgrade) => {
            if (cur[upgrade.upgradeId])
                cur[upgrade.upgradeId]++;
            else
                cur[upgrade.upgradeId] = 1;
            return cur;
        }, {});
    },
    upgradeCountsByUpgradeId(order) {
        return order.upgrades.reduce((cur, upgrade) => {
            // TODO - handle canceled upgrades
            // if (upgrade.state === "Canceled") return cur;
            if (cur[upgrade.upgradeId])
                cur[upgrade.upgradeId]++;
            else
                cur[upgrade.upgradeId] = 1;
            return cur;
        }, {});
    },
    upgradeIsScannable(orderUpgrade) {
        if (!orderUpgrade)
            return false;
        const { scan = {}, refund = {} } = orderUpgrade;
        if (scan.scanned && scan.scannedAt > 0)
            return false;
        if (refund.refunded && refund.refundedAt > 0)
            return false;
        return true;
    },
    /*****************************************************************************************
    Custom Field
    *****************************************************************************************/
    customField(order, eventCustomFieldId) {
        var _a, _b;
        return (_b = (_a = order === null || order === void 0 ? void 0 : order.customFields) === null || _a === void 0 ? void 0 : _a.find((customField) => customField.customFieldId === eventCustomFieldId)) !== null && _b !== void 0 ? _b : null;
    }
};
//# sourceMappingURL=OrderUtil.js.map